<template>
    <div>
        <p>{{ checkInStatus }}</p>
    </div>
</template>

<script>
export default {
    'name': 'ClinicCheckIn',
    'computed': {
        checkInCode () {
            return (this.$route.query && this.$route.query.checkInCode) ? this.$route.query.checkInCode : '';
        }
    },
    mounted () {
        if (this.checkInCode) {
            this.checkInStatus = 'Checking-in to clinic...';

            this.axios.get(`Clinic/CheckIn?checkInCode=${this.checkInCode}`).then(({ data }) => {
                this.checkInStatus = 'Successfully check-in to clinic! You may close this page now.';
            });
        } else {
            this.checkInStatus = 'Error check-in. Please try again.';
        }
    },
    data () {
        return {
            'checkInStatus': ''
        };
    }
};
</script>
